import { render, staticRenderFns } from "./ModalMakePayment.vue?vue&type=template&id=be98ece4&scoped=true&"
import script from "./ModalMakePayment.vue?vue&type=script&lang=ts&"
export * from "./ModalMakePayment.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMakePayment.vue?vue&type=style&index=0&id=be98ece4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be98ece4",
  null
  
)

export default component.exports